<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Показать ' + this.topCount : 'Показать все'" :expandable="items.length > topCount">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        Счета в банках ({{items.length}})
        <v-layout row wrap align-left>
          <template v-for="item in topItems">
          <v-flex>
            <b><component :is="createBankTitle(item)"></component></b>
            <v-flex pl-2> 
              <component :is="createBankContent(item)"></component>
            </v-flex>
          </v-flex>
          </template>
       </v-layout>
      </div>  
    </v-panel-title>
    <v-card-text v-show="isLoaded && items.length > 0" class="pt-0">
      <template v-for="item in lastItems">
          <v-flex>
            <b><component :is="createBankTitle(item)"></component></b>
            <v-flex pl-2> 
              <component :is="createBankContent(item)"></component>
            </v-flex>
          </v-flex>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import vPanelTitle from './PanelTitle'
  import favorite from '../favorite/index.js'

  export default {
    name: 'v-banks-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      isLoaded: false,
      isLoading: false,
      topCount: 1
    }),
    props: {
      fillHeight: {
        type: Boolean,
        default: false
      },
      banks: {
        type: Array,
        default () {
          return []
        }
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters({
      }),
      topItems () {
        return this.items.slice(0, this.topCount)
      },
      lastItems () {
        return this.items.slice(this.topCount)
      },
      items () {
        return this.banks
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
      },
      createBankTitle (item) {
        let strategy = favorite.createStrategy(this, 'COMPANY_BANK')
        if (strategy && strategy.viewTitleComp) {
          return strategy.viewTitleComp(strategy.createModelFromData(item))
        }
        return formats.createComp('<span>Новый тип документа</span>')
      },
      createBankContent (item) {
        let strategy = favorite.createStrategy(this, 'COMPANY_BANK')
        if (strategy && strategy.viewContentComp) {
          return strategy.viewContentComp(strategy.createModelFromData(item))
        }
        return formats.createComp('<span></span>')
      }
    }
  }

</script>


// WEBPACK FOOTER //
// BanksPanel.vue?887ce06c